import { useState, useEffect } from "react";
import Trailer from "./Trailer";
import { useDispatch, useSelector } from 'react-redux';
import RequisitionAction from '../../../../../../../Store/Component/Requisition/RequisitionAction'

const TrailerContainer = (props:any) => {
  const managedEquipRef = props?.managedEquipRef;
  const dispatch = useDispatch();

  const [manufacturerDropDownList, setManufacturerDropDownList] = useState<any>([]);
  const [StyleDropDownList, setStyleDropDownList] = useState<any>([]);
  const [lengthDropDownList, setLengthDropDownList] = useState<any>([]);
  const [fuelTankDropDownList, setFuelTankDropDownList] = useState<any>([]);
  const [chargingStationDropdownList, setChargingStationDropdownList] = useState<any>([]);

  const { managedEquipmentDropDown, managedEquipmentValues, editRequestDetails, isEditRequestClick }: any = useSelector((state? : any) => ({
    managedEquipmentDropDown: state.ManagedEquipmentDropDownReducer.managedEquipmentDropDown,
    managedEquipmentValues: state.RequisitionReducer.managedEquipmentValues,
    editRequestDetails: state.RequisitionReducer.editRequestDetails,
    isEditRequestClick: state.RequisitionReducer.isEditRequestClick,
  }));

  ///Modified dropDown values as required
  useEffect(()=>{
    if (managedEquipmentDropDown?.length > 0) {
      managedEquipmentDropDown?.map((item: any) => {
        if (item?.dropdownName == "Manufacturer") {
          const defaultManufacturerOption = {
            text: "Select Manufacturer",
            value: null
        };
        item?.dropdownList?.unshift(defaultManufacturerOption);
          let manufacturerDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setManufacturerDropDownList(manufacturerDropdownListTemp)
        } else if (item?.dropdownName == "Category") {
          const defaultStyleOption = {
            text: "Select Style",
            value: null
        };
        item?.dropdownList?.unshift(defaultStyleOption);
        let styleDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setStyleDropDownList(styleDropdownListTemp)
        }else if (item?.dropdownName == "Length") {
          const defaultLengthOption = {
            text: "Select Length",
            value: null
        };
        item?.dropdownList?.unshift(defaultLengthOption);
        let lengthDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setLengthDropDownList(lengthDropdownListTemp)
        }else if (item?.dropdownName == "Fuel Tank") {
          const defaultFuelTankOption = {
            text: "Select Fuel Tank",
            value: null
        };
        item?.dropdownList?.unshift(defaultFuelTankOption);
        let fuelTankDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setFuelTankDropDownList(fuelTankDropdownListTemp)
        }else if (item?.dropdownName == "Charging Station") {
          const defaultChargingStationOption = {
            text: "Select Charging Station",
            value: null
        };
        item?.dropdownList?.unshift(defaultChargingStationOption);
        let chargingStationDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setChargingStationDropdownList(chargingStationDropdownListTemp)
        }
      })
    }
  },[managedEquipmentDropDown])

  useEffect(()=> {
    if (isEditRequestClick) {
      let managedEquipmentValuesTemp: any = {}
      let selectedManufacturer: any = ""
      let selectedStyle: any = ""
      let selectedLength: any = ""
      let selectedFuelTank: any = ""
      let selectedChargingStation: any = ""
      
      if (editRequestDetails?.manufacturer && manufacturerDropDownList?.length > 0) {
        selectedManufacturer = manufacturerDropDownList?.find((option: any) => option?.value === editRequestDetails?.manufacturer)
      }

      if (editRequestDetails?.style && StyleDropDownList?.length > 0) {
        selectedStyle = StyleDropDownList?.find((option: any) => option?.value === editRequestDetails?.style)
      }

      if (editRequestDetails?.length && lengthDropDownList?.length > 0) {
        selectedLength = lengthDropDownList?.find((option: any) => option?.value === editRequestDetails?.length)
      }

      if (editRequestDetails?.fuelTank && fuelTankDropDownList?.length > 0) {
        selectedFuelTank = fuelTankDropDownList?.find((option: any) => option?.value === editRequestDetails?.fuelTank)
      }

      if (editRequestDetails?.chargingStation && chargingStationDropdownList?.length > 0) {
        selectedChargingStation = chargingStationDropdownList?.find((option: any) => option?.value === editRequestDetails?.chargingStation)
      }

      managedEquipmentValuesTemp = { 
        ...managedEquipmentValues, 
        manufacturer: selectedManufacturer, 
        style: selectedStyle,
        length: selectedLength,
        fuelTank: selectedFuelTank,
        chargingStation: selectedChargingStation
      }
      dispatch(RequisitionAction.setManagedEquipmentValues(managedEquipmentValuesTemp))
    }
  }, [isEditRequestClick, manufacturerDropDownList, StyleDropDownList, lengthDropDownList, fuelTankDropDownList, chargingStationDropdownList])

useEffect(()=> {
  props.managedEquipRef.current[1]?.focus()
},[])

  const handleManufacturerChange = (e:any,item:any,name:string) => {
    dispatch(RequisitionAction.setManagedEquipmentValues({
      ...managedEquipmentValues,
      [name]: item
  }));
    if(item.label !== 'Select Manufacturer') {
      props.managedEquipRef.current[2]?.focus()
    }
  }
  const handleStyleChange = (e:any,item:any,name:string) => {
    dispatch(RequisitionAction.setManagedEquipmentValues({
      ...managedEquipmentValues,
      [name]: item
  }));
    if(item.label !== 'Select Style') {
      props.managedEquipRef.current[3]?.focus()
    }
  };

  

  const handleLengthChange = (e:any,item:any,name:string) => {
    dispatch(RequisitionAction.setManagedEquipmentValues({
      ...managedEquipmentValues,
      [name]: item
  }));
    if(item.label !== 'Select Length') {
      props.managedEquipRef.current[4]?.focus()
    }
  }

  const handleFuelTankChange = (e:any,item:any,name:string) => {
    dispatch(RequisitionAction.setManagedEquipmentValues({
      ...managedEquipmentValues,
      [name]: item
  }));
    if(item.label !== 'Select Fuel Tank') {
      props.managedEquipRef.current[5]?.focus()
    }
  }

  const handleChargingStationChange = (e:any,item:any,name:string) => {
    dispatch(RequisitionAction.setManagedEquipmentValues({
      ...managedEquipmentValues,
      [name]: item
  }));

    if(item.label !== 'Select charging Station') {
      props.managedEquipRef.current[8]?.focus()
    }
  }
  return (
    <Trailer
    managedEquipmentValues={managedEquipmentValues}
    manufacturerDropDownList={manufacturerDropDownList}
    StyleDropDownList={StyleDropDownList}
    lengthDropDownList={lengthDropDownList}
    fuelTankDropDownList={fuelTankDropDownList}
    chargingStationDropdownList={chargingStationDropdownList}
    managedEquipRef={managedEquipRef}
    handleManufacturerChange={handleManufacturerChange}
    handleStyleChange={handleStyleChange}
    handleLengthChange={handleLengthChange}
    handleFuelTankChange={handleFuelTankChange}
    handleChargingStationChange={handleChargingStationChange}
    />
  )
}

export default TrailerContainer;
